import React from "react";
import {
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { useState } from "react";
import { useEffect } from "react";
import ServicesRequest from "../../../service/ServiceRequest";


import SearchComponent from '../../../components/partials/backend/Search/SearchComponent'
import SortToggle from '../../../components/partials/backend/SortToggle/SortToggle'
import FilterComponent from '../../../components/partials/backend/Filter/FilterComponent'
import PaginationComponent from '../../../components/partials/backend/Pagination/PaginationComponent'
import { AgencyString } from "../../../constants/Agency-String";

const Agency = (props) => {

  let serviceRequestObj = new ServicesRequest("agency");


  const [products, setProducts] = useState([]);
  const [paginationObject, setPaginationObject] = useState(null);

  const { config } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [filter, setFilter] = useState("");
  const [nPages, setPage] = useState(0);
  const [page, setCurrentPage] = useState(1);
  const [numberOfItem, setNumberOfItem] = useState(0);

  async function fetchProductList(url = null) {
    setLoading(true);
    console.log("Fetching agency list with params:", { filter, sort, search, page, url });
    
    const response = await serviceRequestObj.getProductList(filter, sort, search, page, url);
    console.log("Agency API response:", response);
    
    if (!response.response) {
      setProducts(response.data);
      setPaginationObject(response.pagination);
      setPage(response.pagination.n_pages)
      setCurrentPage(response.pagination.current_page)
      setNumberOfItem(response.pagination.n_items)
    } else {
      console.error("Agency API request failed:", response);
      // Optionally show user-friendly error message
      // You could add a toast notification here
    }
    props.location.state = {}
    setLoading(false);
  }

  useEffect(() => {

    fetchProductList();
    return () => {
      setProducts([]);
    };
  }, [search, sort, filter]);

  

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="font-weight-bold">Organizzazione</h4>
              </div>
              <div className="create-workform">
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="modal-product-search d-flex">
                    <div className="mr-3 position-relative">
                      <SearchComponent search={search} setSearch={setSearch} setCurrentPage={setCurrentPage}/>
                    </div>

                    {config.can_create && config.is_admin && (
                      <Link
                        to="/agency-add"
                        className="btn btn-primary position-relative d-flex align-items-center justify-content-between"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="mr-2"
                          width="20"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          />
                        </svg>
                        Aggiungi Struttura
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col lg="12">
                <Card className="card-block card-stretch">
                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <table className="table data-table mb-0">
                        <thead className="table-color-heading">
                          <tr className="text-light">
                            <th scope="col" style={{ width: "20%" }}>
                              <label className="text-muted m-0">
                                {AgencyString.name}
                              </label>
                              <SortToggle
                                field="name"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                id={1}
                              ></SortToggle>
                            </th>

                            <th scope="col" style={{ width: "15%" }}>
                              <label className="text-muted m-0">
                                {AgencyString.address}
                              </label>
                              <SortToggle
                                field="address"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                sort={sort}
                                id={2}
                              ></SortToggle>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "15%" }}
                            >
                              <label className="text-muted m-0">
                                {AgencyString.city}
                              </label>
                              <SortToggle
                                field="city"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                sort={sort}
                                id={3}
                              ></SortToggle>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "18%" }}
                            >
                              <label className="text-muted m-0">
                                Oppurtunite Attive
                              </label>
                              <SortToggle
                                field="closing_date"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                sort={sort}
                                id={4}
                              ></SortToggle>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "18%" }}
                            >
                              <label className="text-muted m-0">Prodotti</label>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "12%" }}
                            >
                              <label className="text-muted m-0">{AgencyString.type}</label>
                            </th>

                              { config && (config.is_admin || config.is_agency_boss || config.is_agency_admin || config.is_business_manager || config.is_internal_backoffice_manager || config.is_institute_backoffice_operator) &&
                              (<th
                                scope="col text-center d-flex align-items-center"
                                style={{ width: "10%" }}
                              >
                                <label className="text-muted mb-0" >{AgencyString.actions}</label>
                                {/* <input type="text" className="form-control mt-2" id="text3" aria-describedby="textHelp" placeholder="Quantity"> */}

                                {/* {!config.is_admin ? (
                                  ""
                                ) : (
                                  <FilterComponent filter={filter} setFilter={setFilter} setCurrentPage={setCurrentPage} />
                                )} */}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody className="smooth-transition">
                          {loading ? (
                            <tr style={{ height: "100px", paddingTop: "10px" }}>
                              <td>
                                <p className="loader"></p>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {products.map((item, index) => (

                                <tr key={index} className="white-space-no-wrap">

                                  <td className="" style={{ width: "20%" }}>
                                    <div className="active-project-1 d-flex align-items-center mt-0 ">
                                      <div className="data-content">
                                        <div>
                                          <span className="font-weight-bold">
                                            {item.name.length > 20
                                              ? 
                                              (item.name.substring(0, 20)+"...") :item.name}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <td style={{ width: "15%" }}> {item.address === null ?  <></> : item.address.length> 20
                                              ? 
                                              (item.address.substring(0, 20)+"...") :item.address}</td>

                                  <td style={{ width: "15%" }} className="text-left">
                                    {item.city}
                                  </td>

                                  <td style={{ width: "25%" }} className="text-left">
                                    {item.active_opportunities_count}
                                  </td>

                                  <td style={{ width: "18%" }} className="text-left">
                                    {item.products_enabled && item.products_enabled.length > 0 ? (
                                      (() => {
                                        const names = item.products_enabled.map(p => p && p.name).filter(Boolean);
                                        const full = names.join(", ");
                                        const display = full.length > 20 ? full.substring(0, 20) + "..." : full;
                                        return (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id={`tooltip-products-${index}`}>{full}</Tooltip>}
                                          >
                                            <span>{display}</span>
                                          </OverlayTrigger>
                                        );
                                      })()
                                    ) : (
                                      <></>
                                    )}
                                  </td>

                                  <td style={{ width: "12%" }} className="text-left">
                                    {
                                      item.is_internal_backoffice ? 'BO Interno' : (
                                        item.is_institute_backoffice ? 'BO Istituto' : 'Agenzia'
                                      )
                                    }
                                  </td>

                                  { config && (config.is_admin || config.is_agency_boss || config.is_agency_admin || config.is_business_manager || config.is_internal_backoffice_manager || config.is_institute_backoffice_operator) &&
                                    (<td style={{ width: "10%" }} >
                                      <div className="d-flex justify-content-start align-items-center">

                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip>
                                              {config.is_admin ? "Edit" : "View"}
                                            </Tooltip>
                                          }
                                        >
                                          <Link to={{ pathname: `/agency-view/${item.id}`, state: {"filter" : filter, 
                                                                                                    "sort" : sort, 
                                                                                                    "search" : search, 
                                                                                                    "page" : page} }}>
                                            {config.is_admin ? (
                                              <>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  className="text-secondary mx-4"
                                                  width="20"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  stroke="currentColor"
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                  />
                                                </svg>
                                              </>
                                            ) : (
                                              <>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  className="text-secondary mx-4"
                                                  width="20"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  stroke="currentColor"
                                                >
                                                  <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                                                </svg>
                                              </>
                                            )}
                                          </Link>
                                        </OverlayTrigger>

                                        {!config.is_admin ? (
                                          ""
                                        ) : (
                                          <>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={<Tooltip>Delete</Tooltip>}
                                            >
                                              <h6
                                                className="badge bg-danger"
                                                onClick={async () => {
                                                  const resp =
                                                    await serviceRequestObj.deleteProduct(item.id);
                                                  if (resp !== null) {
                                                    await fetchProductList();
                                                  }
                                                }}
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="20"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  stroke="currentColor"
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                  />
                                                </svg>
                                              </h6>
                                            </OverlayTrigger>
                                          </>
                                        )}
                                      </div>
                                    </td>)
                                  }
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {
                      paginationObject !== null?
                      <PaginationComponent fetchList={fetchProductList} paginationObject={paginationObject} nPages={nPages} page={page} numberOfItem={numberOfItem} />
                      :<></>
                    }
                    
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Agency;
